import { firebase } from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/storage";
import "@firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCHXu92H6srfopgBWXSsEUfxRIjurW86r8",
  authDomain: "elha-encuestas.firebaseapp.com",
  projectId: "elha-encuestas",
  storageBucket: "elha-encuestas.appspot.com",
  messagingSenderId: "1031915552117",
  appId: "1:1031915552117:web:a23bc461d9a78f1bb1a73c",
  measurementId: "G-QHBBYGKYNH"
};

firebase.initializeApp(firebaseConfig);
// firebase.analytics();

// utils
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const functions = firebase.functions();

const firestore = firebase.firestore;

// collection references
const usersCollection = db.collection("users");
const companiesCollection = db.collection("companies");
const surveysCollection = db.collection("surveys");
const actionPlansCollection = db.collection("actionPlans");

// const sectionsCollection = id =>
//   surveysCollection.doc(id).collection("sections");

// const questionsCollection = id =>
//   surveysCollection.doc(id).collection("questions");

const questionsCollection = id =>
  surveysCollection.doc(id).collection("questions");
const sectionsCollection = id =>
  surveysCollection.doc(id).collection("sections");

const scaleCollection = id => surveysCollection.doc(id).collection("scale");

const filtersCollection = id => surveysCollection.doc(id).collection("filters");

const writtenAnswersCollection = surveyId =>
  surveysCollection.doc(surveyId).collection("writtenAnswers");
const answersCollection = surveyId =>
  surveysCollection.doc(surveyId).collection("answers");
const levelsCollection = surveyId =>
  surveysCollection.doc(surveyId).collection("hierarchyLevels");
const optionsCollection = surveyId =>
  surveysCollection.doc(surveyId).collection("hierarchyOptions");
const categoriesCollection = surveyId =>
  surveysCollection.doc(surveyId).collection("categories");

// export utils/refs
export {
  db,
  auth,
  usersCollection,
  companiesCollection,
  surveysCollection,
  actionPlansCollection,
  storage,
  functions,
  firestore,
  answersCollection,
  writtenAnswersCollection,
  levelsCollection,
  optionsCollection,
  categoriesCollection,
  sectionsCollection,
  questionsCollection,
  scaleCollection,
  filtersCollection
};
